module.exports = __webpack_public_path__ + "img/plane_ac.6c971ee6.svg";